import React, { useEffect, useRef, useState } from "react";
import { cn } from "../../lib/utils";

/**
 * ظاهر شدن نرم محتوا هنگام رسیدن به دید کاربر.
 * فقط جنبه‌ی ظاهری دارد و روی منطق صفحات اثری ندارد.
 */
export default function Reveal({
  as: Tag = "div",
  delay = 0,
  className,
  children,
  ...props
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      style={{ "--reveal-delay": `${delay}ms` }}
      className={cn("reveal", visible && "is-visible", className)}
      {...props}
    >
      {children}
    </Tag>
  );
}
